import NoResultsFound from '@/common/components/NoResultsFound/NoResultsFound'
import OrderListItem from '@/returns/components/OrderListItem/OrderListItem'

import NoViewsAvailable from './NoViewsAvailable/NoViewsAvailable'
import TransactionsListSkeleton from './TransactionsListSkeleton/TransactionsListSkeleton'

const TransactionsList = ({
  orders,
  loading,
  getReturnLink,
  onChangeStatus,
  selectedOrders,
  onCheckOrder,
  showCheckBox,
  isUnifiedDashboard,
  getStoreNameById,
  hasAvailableViews = true,
}) => {
  if (loading) {
    return <TransactionsListSkeleton />
  }

  if (!hasAvailableViews) {
    return <NoViewsAvailable />
  }

  if (!orders?.length) {
    return <NoResultsFound />
  }

  return orders.map(order => (
    <OrderListItem
      key={order.id}
      href={getReturnLink(order.id)}
      onChangeStatus={onChangeStatus}
      info={order}
      currency={order?.currency}
      selected={selectedOrders.includes(order.id)}
      onCheckOrder={e => onCheckOrder(e, order.id)}
      showCheckBox={showCheckBox}
      storeName={isUnifiedDashboard && getStoreNameById(order.store_id)}
    />
  ))
}

export default TransactionsList
